export function LoadingScreen({ label = "Загрузка..." }: { label?: string }) {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-[var(--bg)] px-6 text-[var(--text)]">
      <div className="rounded-[var(--radius-lg)] border border-[var(--border)] bg-[var(--surface)] px-6 py-5 shadow-[0_10px_30px_rgba(15,23,42,0.06)]">
        <div className="text-[12px] font-semibold">{label}</div>
      </div>
    </div>
  );
}
